import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import { Button, message, Popconfirm, Space } from 'antd';
import MakeOrderListForm from '@/pages/MakeOrderListForm';
import { PlusOutlined } from '@ant-design/icons';
import ajax from '@/scripts/ajax';
import localforage from 'localforage';
import dayjs from 'dayjs';

let dataSaver = {};

export default function MakeOrderList() {
    const [list, setList] = useState([]);
    const [killAllLoading, setKillAllLoading] = useState(false);

    useEffect(() => {
        localforage.getItem('spacem_cache').then((res) => {
            if (res) {
                dataSaver = res;
                setList(Object.keys(res));
            }
        });
    }, []);

    const handleAdd = () => {
        setList([...list, Math.floor(Math.random() * 1000000) + 'X']);
    };

    const handleKillAll = async () => {
        setKillAllLoading(true);
        const res = await ajax.get('book/kill');
        setKillAllLoading(false);
        message.info(res);
    };

    const handleValueChange = (id, formValue) => {
        if (formValue === 'delete') {
            delete dataSaver[id];
            setList(list.filter((item) => item !== id));
        } else {
            Object.keys(formValue).forEach((key) => {
                if (key === 'earliest_departure_date') {
                    formValue[key] = dayjs(formValue[key]).format('YYYY-MM-DD HH:mm:ss');
                }
            });
            dataSaver[id] = formValue;
        }
    };

    const handleSave = () => {
        Object.keys(dataSaver).forEach(item => {
            dataSaver[item].earliest_departure_date = dayjs(dataSaver[item].earliest_departure_date).format('YYYY-MM-DD HH:mm:ss');
            console.log(dataSaver[item].earliest_departure_date);

        });
        localforage
            .setItem('spacem_cache', dataSaver)
            .then((res) => {
                message.success('保存成功');
            })
            .catch(() => {
                message.error('保存失败');
            });
    };

    return (
        <div className="ax-page-list">
            <PageHeader
                title="订舱"
                sticky
                extra={
                    <Space>
                        <Popconfirm title="确认" description="是否执行该操作?" onConfirm={handleKillAll} okText="是" cancelText="否">
                            <Button danger loading={killAllLoading}>
                                结束所有进程
                            </Button>
                        </Popconfirm>
                        <Button onClick={handleSave} type="primary" ghost>
                            保存
                        </Button>
                    </Space>
                }
            />
            {list.map((item) => {
                return (
                    <div key={item} style={{ marginBottom: 12 }}>
                        <MakeOrderListForm onValueChange={handleValueChange} id={item} cache={dataSaver[item]}></MakeOrderListForm>
                    </div>
                );
            })}
            <Button size="large" type="dashed" icon={<PlusOutlined />} onClick={handleAdd}>
                添加订舱模块
            </Button>
        </div>
    );
}
